<template>
  <section>
    <div class="row" v-if="handouts.length > 0">
      <div class="col">
        <span v-for="handout in handouts">
          <a :href="handout.url" target="_blank" download>{{ handout.name }}</a><br>
        </span>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col">
        <span>{{ $t('list.efile.message.no-efile') }}</span>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: 'event-handout-list',
  props: {
    handouts: {
      type: Array,
      required: true
    }
  },
  methods: {
    // 
  },
  created() {
    // 
  },
  components: {
    // 
  }  
}
</script>